import { z } from 'zod';

const webEnvSchema = z.object({
    VITE_API_URL: z.string().optional(),
    VITE_APP_NAME: z.string().optional(),
    VITE_SUPABASE_URL: z.string().optional(),
    VITE_SUPABASE_ANON_KEY: z.string().optional(),
    VITE_SKIP_AUTH: z.string().optional(),
    VITE_HTTPS: z.string().optional(),
});

export type WebEnv = z.infer<typeof webEnvSchema>;

export interface WebConfig {
    apiUrl: string;
    appName: string;
    supabaseUrl: string;
    supabaseAnonKey: string;
    skipAuth: boolean;
    https: boolean;
}

export function getWebConfig(env: unknown): WebConfig {
    const parsed = webEnvSchema.parse(env);

    return {
        apiUrl: parsed.VITE_API_URL || 'http://localhost:8787',
        appName: parsed.VITE_APP_NAME || 'MEMORAI',
        supabaseUrl: parsed.VITE_SUPABASE_URL || '',
        supabaseAnonKey: parsed.VITE_SUPABASE_ANON_KEY || '',
        skipAuth: parsed.VITE_SKIP_AUTH === 'true',
        https: parsed.VITE_HTTPS === 'true',
    };
}

